/**
 * Reservation modal controller.
 *
 * The OpenTable widget is loaded inside a `srcdoc` <iframe>. An iframe is a
 * separate document, so the widget's stylesheet is fully sandboxed and can
 * NEVER alter the site's CSS (this is what previously changed the page font).
 * Because srcdoc is same-origin, we can still style the widget (inside the
 * iframe) and auto-size the iframe to its content.
 *
 * The iframe is built on page load, so the widget is already rendered and ready
 * the instant the modal opens. The slide animation is pure CSS.
 */
(function () {
  var OPENTABLE_SRC =
    'https://www.opentable.com/widget/reservation/loader' +
    '?rid=1283941&domain=com&type=standard&theme=standard&color=1' +
    '&dark=false&lang=en-US&iframe=false&newtab=true&overlay=false';

  // This document runs INSIDE the iframe. Its <style> is scoped to the iframe,
  // so nothing here can reach the parent page. base target=_blank sends the
  // OpenTable booking flow to a new tab instead of navigating the iframe.
  var SRCDOC =
    '<!doctype html><html><head><meta charset="utf-8"><base target="_blank">' +
    '<style>' +
    'html,body{margin:0;padding:0;background:transparent;}' +
    'body{display:flex;justify-content:center;align-items:flex-start;}' +
    '#ot-reservation-widget{background:transparent !important;}' +
    '#ot-reservation-widget .ot-dtp-picker,' +
    '#ot-reservation-widget .ot-dtp-picker-form,' +
    '#ot-reservation-widget .ot-dtp-picker-selector{background:transparent !important;background-color:transparent !important;}' +
    '#ot-reservation-widget .ot-button{background-color:#6e3532 !important;border-color:#6e3532 !important;}' +
    '#ot-reservation-widget .ot-button:hover,' +
    '#ot-reservation-widget .ot-button:focus{background-color:#5a2b28 !important;border-color:#5a2b28 !important;}' +
    '</style></head><body>' +
    '<script type="text/javascript" src="' + OPENTABLE_SRC + '"><\/script>' +
    '</body></html>';

  var modal = document.querySelector('[data-reservation-modal]');
  if (!modal) return;

  var host = modal.querySelector('[data-reservation-widget]');
  var layers = window.BaldiLayers;
  var built = false;

  function buildWidget() {
    if (built || !host) return;
    built = true;

    var iframe = document.createElement('iframe');
    iframe.className = 'reservation-modal__widget-iframe';
    iframe.title = 'OpenTable reservation widget';
    iframe.setAttribute('scrolling', 'no');
    iframe.style.height = '280px'; // sensible default until measured

    iframe.addEventListener('load', function () {
      var doc;
      try {
        doc = iframe.contentDocument;
      } catch (e) {
        return; // cross-origin (shouldn't happen for srcdoc) — leave default height
      }
      if (!doc || !doc.body) return;

      function fit() {
        var h = doc.body.scrollHeight;
        if (h) iframe.style.height = h + 'px';
      }
      fit();
      // The widget renders asynchronously after the srcdoc loads — keep the
      // iframe sized to its content as it grows.
      if (window.ResizeObserver) {
        new ResizeObserver(fit).observe(doc.body);
      } else {
        var ticks = 0;
        var timer = window.setInterval(function () {
          fit();
          if (++ticks > 24) window.clearInterval(timer);
        }, 250);
      }
    });

    iframe.srcdoc = SRCDOC;
    host.appendChild(iframe);
  }

  function open() {
    buildWidget(); // guarded — normally already built by the preload below
    modal.classList.add('reservation-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    if (layers) layers.lock('reservation');
  }

  function close() {
    modal.classList.remove('reservation-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    if (layers) layers.unlock('reservation');
  }

  function isOpen() {
    return modal.classList.contains('reservation-modal--open');
  }

  var openers = document.querySelectorAll('[data-reservation-open]');
  for (var i = 0; i < openers.length; i++) {
    openers[i].addEventListener('click', open);
  }

  var closers = modal.querySelectorAll('[data-reservation-close]');
  for (var j = 0; j < closers.length; j++) {
    closers[j].addEventListener('click', close);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) close();
  });

  document.addEventListener('baldi:reservation:close', close);

  // Preload the widget (in its isolated iframe) so it's ready on first open.
  buildWidget();
})();
